module.exports = __webpack_public_path__ + "static/media/logo-bg.dca95380.svg";